import React, { Component, Suspense } from 'react';
import { Layout, Menu, Icon, Drawer } from 'antd';
import Media from 'react-media';
import { Redirect, Route, Switch, Link, withRouter } from 'react-router-dom';
import TopRightHeader from './TopRightHeader';
import LeftSider from './LeftSider';
import AppBreadcrumb from './AppBreadcrumb';
import routes from '../../routes';
import './DefaultLayout.less';
import { isMobile } from 'react-device-detect';
import config from 'react-global-configuration';

const { Header, Content, Footer, } = Layout;
//let enviroment = config.get("enviroment");

class DefaultLayout extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        collapsed: false,
        isMobile: false,
        winSize: {
            h: "0px"
        },
        
    };

    componentDidMount = () => {
        const { intl } = this.props;
        //console.log("DefaultLayout mounted ", intl.formatMessage({ id: 'label.hello' }));
    }

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    checkMobile = (matches) => {
        if (matches !== this.state.isMobile) {
            this.setState({
                isMobile: matches
            });
        }
    }

    componentWillMount() {
        this.setState({
            winSize: { h: window.innerHeight + "px" }
        });
    }

    getLayoutStyle = () => {
        if (!(this.state.isMobile || isMobile)) {
            return {
                paddingLeft: this.state.collapsed ? '80px' : '256px',
            };
        }
        return null;
    };

    getHeaderWidthStyle = () => {
        let width = this.state.isMobile || isMobile ? '100%' : this.state.collapsed ? 'calc(100% - 80px)' : 'calc(100% - 256px)';
        return {
            width: width,
        }
    }

    loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>
    render() {

        console.log(isMobile);

        return (
            <Media query="(max-width: 599px)" onChange={matches => this.checkMobile(matches)}>
                {() =>
                    <Layout>
                        {this.state.isMobile || isMobile ?
                            <Drawer
                                width={256}
                                placement="left"
                                closable={true}
                                onClose={this.toggle}
                                visible={this.state.collapsed}
                                className="left-sider-drawer"
                            >
                                <LeftSider collapsed={false} isMobile={true} path="/" location={this.props.location}></LeftSider>
                            </Drawer>
                            : <LeftSider collapsed={this.state.collapsed} isMobile={this.state.isMobile || isMobile} path="/" location={this.props.location}></LeftSider>
                        }
                        <Layout style={{
                            ...this.getLayoutStyle(),
                            minHeight: '100vh'
                        }}>
                            <Header className="fixedHeader" style={{ background: 'rgb(70, 112, 162)', padding: 0, color: 'white', ...this.getHeaderWidthStyle() }}>
                                <Icon
                                    className="trigger"
                                    type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                                    onClick={this.toggle}
                                />
                                <TopRightHeader></TopRightHeader>
                            </Header>
                            <AppBreadcrumb appRoutes={routes} />
                            <Content style={{
                                margin: '5px 15px 5px 15px', minHeight: 280
                            }}
                            >
                                <Suspense fallback={this.loading()}>
                                    <Switch>
                                        {routes.map((route, idx) => {
                                            return route.component ? (
                                                <Route
                                                    key={idx}
                                                    path={route.path}
                                                    exact={route.exact}
                                                    name={route.name}
                                                    render={props => (
                                                        <route.component {...props} />
                                                    )} />
                                            ) : (null);
                                        })}
                                        <Redirect from="/" to="/home" />
                                    </Switch>
                                </Suspense>
                            </Content>
                            <Footer style={{ textAlign: 'center' }}>
                                <strong>Copyright © 2019 <a href="#">SCG Chemicals PLC</a></strong> All rights reserved.
                                (Powered by <a href="https://www.itone.co.th/">IT One</a>)
                                {config.get("enviroment") !== null ? <strong style={{ color: '#f5222d' }}>  ({config.get("enviroment")})</strong> : null}
                            </Footer>
                        </Layout>
                    </Layout>
                }
            </Media>
        )
    }
}

export default withRouter(DefaultLayout);
